import { ReactNode, useEffect, useRef } from "react"
import ReactDOM from "react-dom"
import styles from "./styles.module.scss"
import CloseOutline from "~icons/eva/close-outline"

export function ModalWrapper({
  children,
  onClose,
  closeOnClickOutside = true,
}: {
  children: ReactNode
  onClose?: () => void
  closeOnClickOutside?: boolean
}) {
  const modalRoot = document.getElementById("modal-root")
  const modalContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && onClose) {
        onClose()
      }
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (
        closeOnClickOutside &&
        modalContentRef.current &&
        !modalContentRef.current.contains(event.target as Node) &&
        onClose
      ) {
        onClose()
      }
    }

    document.addEventListener("keydown", handleKeyDown)
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return ReactDOM.createPortal(
    <div className={styles.modalBackground}>
      {onClose ? (
        <button className={styles.closeButton} onClick={() => onClose()}>
          <CloseOutline />
        </button>
      ) : null}
      <div className={styles.modalContent} ref={modalContentRef}>
        {children}
      </div>
    </div>,
    modalRoot,
  )
}
